import React from "react";


const DashboardPlaceholder = React.memo(() => {

    return <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8 animate-pulse">
        <div className="relative rounded mt-12 sm:mt-20 pb-20 sm:pb-24 xl:pb-0">
            <div
                className="mx-auto flex max-w-7xl flex-col items-center gap-x-8 gap-y-10 px-6 sm:gap-y-8 lg:px-8 xl:flex-row xl:items-stretch">
                <div className="-mt-8 w-full max-w-2xl xl:-mb-8 xl:w-96 xl:flex-none">
                    <div className="relative aspect-[2/1] h-full md:-mx-8 xl:mx-0 xl:aspect-auto bg-gray-200"/>
                </div>
                <div className="w-full max-w-2xl xl:max-w-none xl:flex-auto xl:p-16">
                    <div className="relative text-base pt-5 sm:pt-8 bg-gray-200 min-h-[100px]"/>
                </div>
            </div>
        </div>
        <div className="mt-24">
            <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-2 lg:gap-x-8 lg:px-8 lg:gap-y-20">
                <div className="flex flex-col rounded-2xl bg-gray-200 shadow-sm min-h-[220px]">
                    <div className="relative flex-1 px-6 pb-8 pt-16 md:px-8"/>
                </div>
                <div className="flex flex-col rounded-2xl bg-gray-200 shadow-sm min-h-[220px]">
                    <div className="relative flex-1 px-6 pb-8 pt-16 md:px-8"/>
                </div>
            </div>
        </div>
    </div>
})

export default DashboardPlaceholder;